class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    $("#cyccartdrawer").addClass("active");
    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        //trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    setTimeout(()=> {
      cartLikeit();
    },1000);

     if (typeof cycupdatepointscartdrawer === 'function') {
              cycupdatepointscartdrawer(); 
            } else {
              console.log("cycupdatepointscartdrawer is not defined!");
            } 
    
    setTimeout(()=> {
      if (typeof cycupdatepointscartdrawer === 'function') {
              cycupdatepointscartdrawer(); 
            } else {
              console.log("cycupdatepointscartdrawer is not defined!");
            } 
    },1000);


  }

  close() {
    this.classList.remove('active');
    //removeTrapFocus(this.activeElement);
    $("#cyccartdrawer").removeClass("active");
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log("renderContents");
    //console.log(parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      //console.log(this.getSectionInnerHTML(parsedState.sections[section.id], section.selector));
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
       cartLikeit();  
    });
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

//ADA focus Trap for drawer.
/** 
(function () {
  let trapContainer = null;
  let focusableElements = [];
  let firstFocusable = null;
  let lastFocusable = null;

  function setFocusTrap(container) {
    trapContainer = container;

    focusableElements = trapContainer.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input:not([disabled]), select, [tabindex]:not([tabindex="-1"])'
    );

    focusableElements = Array.from(focusableElements).filter(el =>
      !el.hasAttribute('disabled') && !el.getAttribute('aria-hidden')
    );

    firstFocusable = focusableElements[0];
    lastFocusable = focusableElements[focusableElements.length - 1];

    // Move focus into the drawer
    if (firstFocusable) firstFocusable.focus();

    document.addEventListener('keydown', trapTabKey);
  }

  function removeFocusTrap() {
    document.removeEventListener('keydown', trapTabKey);
    trapContainer = null;
  }

  function trapTabKey(e) {
    if (!trapContainer) return;

    if (e.key === 'Tab') {
      if (e.shiftKey) {
        // SHIFT + TAB
        if (document.activeElement === firstFocusable) {
          e.preventDefault();
          lastFocusable.focus();
        }
      } else {
        // TAB
        if (document.activeElement === lastFocusable) {
          e.preventDefault();
          firstFocusable.focus();
        }
      }
    }
  }

  // Observe for drawer open/close
  var cyctarget = document.querySelector('[data-cart-drawer]');
  const observercyc = new MutationObserver(() => {
    //observercyc.disconnect();
  const drawer = document.querySelector('[data-cart-drawer].active');

    if (drawer) {
      console.log("CYC FOCUS FIRE");
      setFocusTrap(drawer);
    } else {
      removeFocusTrap();
    }
  });

  observercyc.observe(document.body, { childList: true, subtree: true, attributes: true });
})();
 */


